import { NavigationTab } from 'shared/model';

import { AddRoleButtonLink } from './buttons';

export const TABS: Array<NavigationTab> = [
  {
    key: 'roles',
    path: '',
    label: 'Управление ролями',
    buttons: [
      {
        element: <AddRoleButtonLink />,
        controller: 'Identity',
        right: 'Write',
      },
    ],
  },
];
